<div id="hhseekandfind_Dialog" 
    appDraggable dragTarget="#hhseekandfind_Dialog" dragHandle="#hhseekandfind_DialogHeader"
    class="modal fade in ui-draggable ui-draggable-handle locationAlertDataPane"
    style="width:auto; min-width: 450px; max-width: 100%; min-height: 200px; height: auto; overflow-y: auto; max-height: 100%; display: none;"
    role="dialog"
    tabindex="-1"
    >

    <div role="document" id="hhseekandfind_DialogContent">
        <div class="modal-content modal-dialog">

            <div class="modal-header" id="hhseekandfind_DialogHeader">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="onCancelClicked()">
                    <span aria-hidden="true">x</span>
                </button>
                <h4 class="modal-title">
                    <span>{{ op?.id? "Update '" + op.label +  "' (" + op.id + ")" : "Create New Operation" }}</span>
                </h4>

                <div class="modal-body" *ngIf="op != null">
                    <p> Message </p>

                    <!-- Button Label -->
                    <div class="row">
                        <div class="form-group">
                            <div class="col-sm-4"><label class="labelRequired">Button Label</label></div>
                            <div class="col-sm-8"><input class="form-control" type="text" [(ngModel)]="op.label" /></div>
                        </div>
                    </div>

                    <!-- Encoding Type -->
                    <div class="row">
                        <label class="col-sm-4 labelRequired">Encoding Type</label>
                        <span class="col-sm-8">
                            <select class="form-control" style="color: #dcdcdc" [(ngModel)]="op.encoding_type" (ngModelChange)="refreshTagProperties()">
                                <option [ngValue]="null"> -- Choose -- </option>
                                <ng-container *ngIf="encodingSchemeTypes != null">
                                    <option *ngFor="let encodingType of encodingSchemeTypes" [ngValue]="encodingType">
                                        {{ encodingType?.name }}
                                    </option>
                                </ng-container>
                            </select>
                        </span>
                    </div>

                    <!-- Main Property -->
                    <div class="row">
                        <label class="col-sm-4 labelRequired">Main Property</label>
                        <span class="col-sm-8">
                            <select class="form-control" style="color: #dcdcdc" [(ngModel)]="op.main_property">
                                <option [ngValue]="null"> -- Choose -- </option>
                                <ng-container *ngIf="op?.encoding_type?.properties?.length > 0">
                                    <option *ngFor="let property of op.encoding_type.properties" [ngValue]="property">
                                        {{ property?.name }}
                                    </option>
                                </ng-container>
                            </select>
                        </span>
                    </div>

                    <!-- Tag Property -->
                    <div class="row">
                        <label class="col-sm-4 labelRequired">Tag Property</label>
                        <span class="col-sm-8">
                            <select class="form-control" style="color: #dcdcdc" [(ngModel)]="op.tag_property">
                                <option [ngValue]="null"> -- Choose -- </option>
                                <option *ngFor="let property of allTagProperties" [ngValue]="property">
                                    {{ property?.name }}
                                </option>
                            </select>
                        </span>
                    </div>
                </div>

                <div class="modal-footer">
                    <button type="button" class="btn btn-default" (click)="onCancelClicked()">
                        <i class="fa fa-ban"></i> CANCEL
                    </button>
                    <button type="button" class="btn btn-primary" (click)="onConfirmClicked()">
                        <i class="fa fa-refresh"></i> {{ op?.id? 'UPDATE' : 'CREATE' }}
                    </button>
                </div>

            </div>
        </div>
    
    </div>
    
</div>